import { forwardRef } from 'react';
import { Divider } from './Divider';
import type { DividerProps } from './Divider';

/**
 * Separator component - alias for Divider to match Radix UI naming
 * Provides all functionality of Divider for consistency with Radix UI
 */
export type SeparatorProps = DividerProps;

const Separator = forwardRef<HTMLDivElement, SeparatorProps>((props, ref) => {
  return <Divider ref={ref} {...props} />;
});

Separator.displayName = 'Separator';

export { Separator };
